import { accScroll } from '../../../shared/page-accordion';

export const reportGoTo = (e) => {
    if (e.target && e.target.hash) {
        accScroll(e.target.hash.replace('#', ''), 300);
    }
};